import { Color, ScaleType } from '@swimlane/ngx-charts';

export class GraphHelper {
	getDefaultColorScheme(): Color {
		return {
			domain: ['#6366f1', '#FF6F61', '#009B77', '#88B04B', '#B565A7'],
			group: ScaleType.Linear,
			name: '',
			selectable: false
		};
	}

	/**
	 * Disables because of bug in ngx-charts in angular 20
	 *
	 * https://github.com/swimlane/ngx-charts/issues/2046
	 */
	isTooltipDisabled: boolean = true;
}

export const graphHelper = new GraphHelper();
